import FeesCard from "./FeesCard";

export default function Class9() {
  return (
    <FeesCard
        badge="Class 9"
        title="💰 Class 9 Tuition Details"
        className="9th Standard"
        fee="₹1,500"
        days="Monday – Saturday"
        time="4:30 PM – 7:30 PM"
        subjects={[
          "Mathematics",
          "Physics",
          "Chemistry",
          "Biology",
          "Social Science"
        ]}
        approach={[
          "Board-level preparation",
          "Concept mastery",
          "Weekly mock tests"
        ]}
        note="₹500 extra for evening snacks / milk.
        Self pickup & drop only."
      />
  );
}